import { Flame, Target } from "@phosphor-icons/react";
import { useT } from "../../contexts/LanguageContext";

export default function StreakWidget({ streak }) {
  const { t } = useT();
  if (!streak) return null;
  const goal = streak.daily_goal || 15;
  const today = streak.today_solved_actual ?? streak.today_solved ?? 0;
  const pct = Math.min(100, Math.round((today / goal) * 100));
  const remaining = Math.max(0, goal - today);

  return (
    <div className="card lg:col-span-3" data-testid="streak-widget">
      <div className="overline flex items-center gap-1"><Flame size={12} weight="fill" className="text-[#E11D48]" /> {t("streak.title")}</div>
      <div className="mt-3 flex items-end gap-3">
        <div>
          <div className="font-display text-5xl font-bold tracking-tight text-[#002FA7]">{streak.current || 0}</div>
          <div className="overline mt-1">{t("streak.days")}</div>
        </div>
        <div className="ml-auto text-right">
          <div className="overline">{t("streak.longest")}</div>
          <div className="font-display text-2xl font-bold mt-1">{streak.longest || 0}</div>
        </div>
      </div>

      <div className="mt-5">
        <div className="flex items-center justify-between text-xs">
          <span className="overline flex items-center gap-1"><Target size={11} weight="bold" /> {t("streak.today")}</span>
          <span className="font-mono font-bold">{today}/{goal}</span>
        </div>
        <div className="mt-2 h-2 bg-slate-100 rounded-full overflow-hidden">
          <div
            className={`h-full transition-all duration-500 ${pct >= 100 ? "bg-[#059669]" : "bg-[#002FA7]"}`}
            style={{ width: `${pct}%` }}
          />
        </div>
        <div className={`text-xs mt-2 ${pct >= 100 ? "text-[#059669] font-semibold" : "text-slate-500"}`}>
          {pct >= 100
            ? t("streak.goal_hit")
            : today === 0
            ? t("streak.start_today")
            : t("streak.keep_going", { remaining })}
        </div>
      </div>
    </div>
  );
}
